import styled from '@emotion/styled';
import { primaryFontFamily } from '../../styles/fonts';

// eslint-disable-next-line import/prefer-default-export
export const SeeMoreAction = styled.button`
  display: block;
  border: 0;
  margin: 0 auto;

  background: transparent;
  color: ${(props) => props.theme.default.colors.n5};

  ${primaryFontFamily}
  font-size: 16px;
  line-height: 24px;

  cursor: pointer;
`;
